(() => {
  // scripts/modules/product.js
  var selectors = {
    mediaCurrent: "[data-media-current]",
    mediaThumbnail: "[data-media-image-thumb]",
    mediaThumbnailsContainer: ".product__media-gallery",
    featuredMediaWrapper: ".product__featured-image",
    featuredImage: "[data-product-featured-image]"
  };
  var elements;
  function getElements() {
    return {
      featuredImage: document.querySelector(selectors.featuredImage),
      thumbnails: document.querySelectorAll(selectors.mediaThumbnail)
    };
  }
  function bindEvents() {
    elements.thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener("click", (event) => {
        if (event) {
          event.preventDefault();
        }
        setFeaturedImage(event);
      });
      thumbnail.addEventListener("mouseover", (event) => {
        setFeaturedImage(event);
      });
    });
  }
  function setFeaturedImage(event) {
    const target = event.currentTarget;
    elements.featuredImage.src = target.dataset.mediaImageTarget;
  }
  function preloadFeaturedImages() {
    elements.thumbnails.forEach((thumbnail) => {
      let img = new Image();
      img.src = thumbnail.dataset.mediaImageTarget;
    });
  }
  function initProductGallery() {
    if (document.querySelector(selectors.mediaThumbnailsContainer) === null) {
      return;
    }
    elements = getElements();
    bindEvents();
    preloadFeaturedImages();
  }

  // scripts/modules/product-recommendations.js
  var selectors2 = {
    productRecommendationsContainer: "[data-product-recommendations-container]",
    productRecommendations: "[data-product-recommendations]"
  };
  var elements2;
  var recommendationsLoaded = false;
  function getElements2() {
    return {
      productRecommendationsContainer: document.querySelector(selectors2.productRecommendationsContainer)
    };
  }
  function showProductRecommendations(productRecommendationsHtml) {
    const productRecommendations = productRecommendationsHtml.querySelector(selectors2.productRecommendations);
    if (!productRecommendations) {
      return;
    }
    elements2.productRecommendationsContainer.appendChild(productRecommendations);
    recommendationsLoaded = true;
  }
  function getProductRecommendationsHTML() {
    const baseUrl = elements2.productRecommendationsContainer.dataset.baseUrl;
    const productId = elements2.productRecommendationsContainer.dataset.productId;
    const recommendationsCount = elements2.productRecommendationsContainer.dataset.recommendationsCount;
    const productRecommendationsUrl = `${baseUrl}?section_id=product-recommendations&product_id=${productId}&limit=${recommendationsCount}`;
    return fetch(productRecommendationsUrl).then((response) => response.text()).then((text) => {
      const parser = new DOMParser();
      return parser.parseFromString(text, "text/html");
    }).catch((error) => {
      throw new Error(error);
    });
  }
  function setupProductRecommendations() {
    getProductRecommendationsHTML().then((productRecommendationsHtml) => {
      showProductRecommendations(productRecommendationsHtml);
    });
  }
  function initProductRecommendations() {
    if (document.querySelector(selectors2.productRecommendationsContainer) === null) {
      return;
    }
    elements2 = getElements2();
    setupProductRecommendations();
  }

  // scripts/modules/header.js
  var drawerOpenClass = "drawer-active";
  var selectors3 = {
    navContainer: "[data-mobile-nav-container]",
    navToggle: "[data-mobile-nav-toggle]",
    navUnderwrap: "[data-mobile-nav-underwrap]"
  };
  var scrollPosition;
  function enableScrollLock() {
    scrollPosition = window.pageYOffset;
    document.body.style.top = `-${scrollPosition}px`;
    document.body.classList.add("prevent-scrolling");
  }
  function disableScrollLock() {
    document.body.classList.remove("prevent-scrolling");
    document.body.style.removeProperty("top");
    window.scrollTo(0, scrollPosition);
  }
  function bindEvents2() {
    const navbar = document.querySelector(selectors3.navContainer);
    const navToggles = document.querySelectorAll(selectors3.navToggle);
    const navUnderwrap = document.querySelector(selectors3.navUnderwrap);
    const body = document.querySelector("body");
    const openMobileNav = () => {
      body.classList.add(drawerOpenClass);
      enableScrollLock();
    };
    const closeMobileNav = () => {
      body.classList.remove(drawerOpenClass);
      disableScrollLock();
    };
    navToggles.forEach((navToggle) => {
      navToggle.addEventListener("click", () => {
        if (body.classList.contains(drawerOpenClass)) {
          closeMobileNav();
        } else {
          openMobileNav();
        }
      });
    });
    document.addEventListener("keyup", function(keyEvent) {
      if (keyEvent.key === "Escape") {
        closeMobileNav();
      }
    });
  }
  function initHeader() {
    if (document.querySelector(selectors3.navContainer) === null) {
      console.log(document.querySelector(selectors3.navContainer), "document.querySelector(selectors.navContainer)");
      console.log("[data-mobile-nav-container] not found");
      return;
    }
    bindEvents2();
  }

  // scripts/modules/modal.js
  var FOCUSABLE_SELECTORS = "[tabindex], [draggable], [href], button:enabled, input:not([type=hidden]):enabled, object, select:enabled, textarea:enabled";
  var keyCodes = {
    ESC: "escape"
  };
  var selectors4 = {
    overlay: "[data-modal-overlay]",
    modal: "[data-modal]",
    open: "[data-modal-open]",
    close: "[data-modal-close]",
    focus: "data-modal-focus"
  };
  var classes = {
    closed: "closed",
    preventScrolling: "prevent-scrolling"
  };
  var elements3 = getElements3();
  var scrollPosition2 = window.pageYOffset;
  var openModal = () => {
    elements3.modal.classList.remove(classes.closed);
    elements3.overlay.classList.remove(classes.closed);
    focusElement(elements3.modal);
    enableScrollLock2();
    elements3.overlay.addEventListener("click", closeModal);
  };
  var closeModal = () => {
    elements3.modal.classList.add(classes.closed);
    elements3.overlay.classList.add(classes.closed);
    disableScrollLock2();
    elements3.overlay.removeEventListener("click", closeModal);
  };
  function focusableSelectors(container) {
    const elements4 = Array.prototype.slice.call(container.querySelectorAll(FOCUSABLE_SELECTORS));
    return elements4.filter(function(element) {
      return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
    });
  }
  function getElements3() {
    return {
      modal: document.querySelector(selectors4.modal),
      overlay: document.querySelector(selectors4.overlay),
      open: document.querySelectorAll(selectors4.open),
      close: document.querySelectorAll(selectors4.close)
    };
  }
  function focusElement(container) {
    const focusables = focusableSelectors(container);
    if (focusables.length > 0) {
      focusables[0].focus();
    }
  }
  function bindEvents3() {
    elements3.open.forEach((openButton) => {
      openButton.addEventListener("click", (event) => {
        if (event) {
          event.preventDefault();
        }
        openModal();
      });
    });
    elements3.close.forEach((closeButton) => {
      closeButton.addEventListener("click", (event) => {
        if (event) {
          event.preventDefault();
        }
        closeModal(event);
      });
    });
    document.addEventListener("keyup", (event) => {
      onKeyUp(event);
    });
  }
  function onKeyUp(event) {
    if (event.key.toLowerCase() === keyCodes.ESC) {
      closeModal();
    }
  }
  function enableScrollLock2() {
    const scrollPosition3 = window.pageYOffset;
    document.body.style.top = `-${scrollPosition3}px`;
    document.body.classList.add(classes.preventScrolling);
  }
  function disableScrollLock2() {
    document.body.classList.remove(classes.preventScrolling);
    document.body.style.removeProperty("top");
    window.scrollTo(0, scrollPosition2);
  }
  function initModal() {
    bindEvents3();
  }

  // scripts/modules/search.js
  var searchOpenClass = "search-active";
  var selectors5 = {
    drawerContainer: "[data-search-container]",
    drawerToggle: "[data-search-toggle]",
    inputFocusTarget: "[data-search-focus]"
  };
  function bindEvents4() {
    const drawerToggle = document.querySelector(selectors5.drawerToggle);
    const inputFocusTarget = document.querySelector(selectors5.inputFocusTarget);
    const body = document.querySelector("body");
    const openSearch = () => {
      console.log("openSearch");
      console.log(inputFocusTarget, "inputFocusTarget");
      window.setTimeout(function() {
        console.log("in timer");
        inputFocusTarget.focus();
      }, 0);
      body.classList.add(searchOpenClass);
    };
    const closeSearch = () => {
      console.log("closeSearch");
      body.classList.remove(searchOpenClass);
    };
    drawerToggle.addEventListener("click", (e) => {
      console.log("click");
      e.preventDefault();
      if (body.classList.contains(searchOpenClass)) {
        closeSearch();
      } else {
        openSearch();
      }
    });
    document.addEventListener("keyup", function(keyEvent) {
      console.log(keyEvent.key, "keyEvent.key");
      if (keyEvent.key === "Escape") {
        console.log("escape");
        closeSearch();
      }
    });
  }
  function initSearch() {
    if (document.querySelector(selectors5.drawerContainer) === null) {
      console.log(`${selectors5.drawerContainer} not found`);
      return;
    }
    bindEvents4();
  }

  // scripts/index.js
  initHeader();
  initModal();
  initProductGallery();
  initProductRecommendations();
  initSearch();
})();
